import { Box } from "@mui/material";
import { useContext } from "react";
import { AccountReportDto, GenerateReportInput } from "../../../api/psc";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import ReportFilter from "../components/ReportFilter";

// updated
export default function ReportFilterDialog(props: {
    report: AccountReportDto;
    isFetching: boolean;
    applyFilter: (GenerateReportInput) => void;
}) {
    const { closeDialog } = useContext(DialogContext);

    const applyFilter = (input: GenerateReportInput) => {
        props.applyFilter(input);
        closeDialog();
    };

    return (
        <DialogContainer>
            <DialogHeader title={"فیلتر گزارش"} />

            <Box sx={{ p: 2 }}>
                <ReportFilter
                    report={props.report}
                    applyFilter={applyFilter}
                    isFetching={props.isFetching}
                />
            </Box>
        </DialogContainer>
    );
}
